<template>
  <div v-show="showCmpt && mergeFlag" class="yxtbiz-merge-evaluation" v-loading="loading">
    <div class="yxtbiz-merge-evaluation__title">
      <yxtf-checkbox v-model="onlyStarted" @change="handleOnlyStartedChange">
        <yxtf-tooltip placement="bottom" :open-filter="true" :content="$t('pc_biz_o2o_lbl_onlyviewstartedtask')">
          <span class="color-59">{{$t('pc_biz_o2o_lbl_onlyviewstartedtask')}}</span>
        </yxtf-tooltip>
      </yxtf-checkbox>
    </div>
    <yxtf-divider></yxtf-divider>
    <div class="over-hidden">
      <yxtf-scrollbar :fit-height="true">
        <div class="yxtbiz-merge-evaluation__body">
          <template v-if="taskList.length > 0">
            <div
              class="yxtbiz-merge-evaluation__task hand"
              v-for="item in taskList"
              :key="item.taskId"
              :class="{ 'eval-item-selected': item.selected }"
              @click="showDetail(item)"
            >
              <div class="font-size-16 lh24" :class="{ 'font-bold': item.selected }">
                <yxtf-tooltip
                  class="item" 
                  :open-filter="true"
                  :content="item.taskName"
                  placement="top"
                >
                  <span class="task-title hand ellipsis d-in-block color-59">
                    {{ item.taskName }}
                  </span>
                </yxtf-tooltip>
              </div>
              <div class="mt4 font-size-12 lh20 merge-evaluation-task-status">
                <yxt-svg
                  :icon-class="svgClass(item)"
                  width="18px"
                  height="18px"
                  :remote-url="`${$staticBaseUrl}ufd/d8a55a/o2o/pc/svg`"
                />
                <div class="inlineBlock ml4 font-size-12 lh20 color-bf">
                  {{ taskStatus(item) }}
                </div>
              </div>
            </div>
          </template>
          <yxtf-empty v-else-if="loadEnd && taskList.length === 0" size="small" class="pv24" />
        </div>
      </yxtf-scrollbar>
    </div>
  </div>
</template>

<script>
import {
  getEvaluateList,
  getEvaluateIsEnable,
  getSimpleProjectInfo
} from './service';
import {
  FrontScrollbar,
  FrontCheckbox,
  FrontDivider,
  FrontSvgIcon,
  FrontTooltip,
  FrontEmpty
} from 'yxt-pc';
export default {
  name: 'YxtbizMergeEvaluation',
  components: {
    YxtScrollbar: FrontScrollbar,
    YxtfCheckbox: FrontCheckbox,
    YxtfDivider: FrontDivider,
    YxtfSvg: FrontSvgIcon,
    YxtfTooltip: FrontTooltip,
    YxtfEmpty: FrontEmpty
  },
  data() {
    return {
      loading: false,
      loadEnd: false,
      onlyStarted: false,
      taskList: [],
      mergeFlag: false
    };
  },
  props: {
    projectId: {
      type: String,
      default: ''
    },
    defaultTaskId: {
      type: String,
      default: ''
    }
  },
  computed: {
    pid() {
      return this.$route.query.mergeEvalProjectId || this.projectId;
    },
    defaultTid() {
      return this.$route.query.mergeEvalTaskId || this.defaultTaskId;
    },
    showCmpt() {
      if (this.onlyStarted && this.taskList.length === 1) {
        return true;
      }
      if (this.taskList.length === 1) {
        return false;
      }
      return true;
    }
  },
  created() {
    this.getProjectInfo();
  },
  methods: {
    getProjectInfo() {
      getSimpleProjectInfo(this.pid).then(res => {
        this.mergeFlag = res.allowSurveyMerging;
        this.getData();
      });
    },
    getData(id = '') {
      this.loading = true;
      this.loadEnd = false;
      this.taskList = [];
      this.defaultTid = id ? id : this.defaultTid;
      getEvaluateList(this.pid, this.onlyStarted ? 1 : 0)
        .then(res => {
          this.loading = false;
          this.loadEnd = true;
          if (res.evaluateLists.length > 0) {
            this.taskList = JSON.parse(JSON.stringify(res.evaluateLists));
            this.taskList.map(item => {
              if (item.taskType === 1) {
                item.taskName =
                  '“' +
                  item.taskName +
                  '”' +
                  this.$t('pc_biz_o2o_lbl_evaluation');
              } else if (item.taskType === 4 && item.taskOwner === 1) {
                item.taskName = `${this.$t('pc_biz_o2o_lbl_evaluatete'/** 评价导师 */)}${item.ojtTeacherName ? '-' + item.ojtTeacherName : ''}-${item.taskName}`;
              } else if (item.taskType === 4 && item.taskOwner === 2) {
                item.taskName = `${this.$t('pc_biz_o2o_lbl_evaluateself'/** 学员自评 */)}-${item.taskName}`;
              }
              item.selected = false;
              return item;
            });
            // 初始化
            let task = this.taskList.find(
              item => item.taskId === (id ? id : this.defaultTid)
            );
            this.showDetail(task || this.taskList[0]);
          } else {
            this.taskList = [];
          }
        })
        .catch(e => {
          this.loading = false;
          this.loadEnd = true;
          this.taskList = [];
          if (e) {
            if (e.error) {
              if (e.error.key === 'apis.o2o.project.deleted') {
                this.$fmessage({ message: this.$t('pc_biz_o2o_msg_projectundefined'), type: 'warning'});
              } else {
                this.$fmessage({ message: e.error.message, type: 'warning'});
              }
            }
          }
        });
    },
    svgClass(task) {
      let classStr = '';
      if (task.status === 1) {
        classStr = 'hollow-lock';
      } else {
        if (task.evalStatus === 0) {
          classStr = 'notsubmit';
        }
        if (task.evalStatus === 1) {
          classStr = 'submit';
        }
      }
      return classStr;
    },
    taskStatus(task) {
      let textStr = '';
      if (task.status === 1) {
        textStr = this.$t('pc_biz_o2o_lbl_unlocked');
      } else {
        if (task.evalStatus === 0) {
          textStr = this.$t('pc_biz_o2o_lbl_unsubmitted');
        }
        if (task.evalStatus === 1) {
          textStr = this.$t('pc_biz_o2o_lbl_submitted');
        }
      }
      return textStr;
    },
    handleOnlyStartedChange() {
      this.loadEnd = false;
      this.getData();
    },
    showDetail(obj) {
      if (obj.selected) {
        return;
      }
      this.defaultTid = obj.taskId;
      if (obj.evalStatus === 1) { // 已提交
        this.taskList = this.taskList.map(item => {
          item.selected = item.taskId === obj.taskId;
          return item;
        });
        let targetId = obj.taskOwner === 1 ? obj.teacherId : obj.userId;
        let objId = ''; // 调查ID，正常评价任务 taskId，带教评价任务 evalCfgId，面授评价 任务中targetId
        if (obj.taskType === 1) {
          objId = obj.targetId;
        } else if (obj.taskType === 4 && [1, 2].includes(obj.taskOwner)) {
          objId = obj.evalCfgId;
        } else {
          objId = obj.taskId;
        }
        let result = {
          id: objId,
          type: 2,
          tid: targetId,
          tname: '',
          success: '',
          batchId: (obj.batchId === '0' || !obj.batchId) ? '' : obj.batchId
        };
        this.$emit('changeSurvey', result, { mergeEvalProjectId: this.pid, mergeEvalTaskId: obj.taskId, showResult: 1 }, true);
      } else { // 未提交
        getEvaluateIsEnable(this.pid, obj.taskId)
          .then(res => {
            if (res.code === 1) {
              this.$fmessage({
                message: this.$t('pc_biz_o2o_lbl_tasknotunlocked'),
                type: 'warning'
              });
              return;
            } else {
              this.taskList = this.taskList.map(item => {
                item.selected = item.taskId === obj.taskId;
                return item;
              });
              let targetId = obj.taskOwner === 1 ? obj.teacherId : obj.userId;
              let objId = ''; // 调查ID，正常评价任务 taskId，带教评价任务 evalCfgId，面授评价 任务中targetId
              if (obj.taskType === 1) {
                objId = obj.targetId;
              } else if (obj.taskType === 4 && [1, 2].includes(obj.taskOwner)) {
                objId = obj.evalCfgId;
              } else {
                objId = obj.taskId;
              }
              let result = {
                id: objId,
                type: 2,
                tid: targetId,
                tname: '',
                success: '',
                batchId: (obj.batchId === '0' || !obj.batchId) ? '' : obj.batchId
              };
              let index = this.taskList.findIndex(item => item.taskId === obj.taskId);
              this.$set(this.taskList[index], 'status', 2);
              this.$emit('changeSurvey', result, { mergeEvalProjectId: this.pid, mergeEvalTaskId: obj.taskId, showResult: 1 });
            }
          })
          .catch(e => {
            if (e) {
              if (e.error) {
                if (e.error.key === 'apis.o2o.task.NotFound') {
                  this.$fmessage({ message: this.$t('pc_biz_o2o_msg_taskundefined'), type: 'warning'});
                } else {
                  this.$fmessage({ message: e.error.message, type: 'warning'});
                }
              }
            }
          });
      }
    }
  }
};
</script>
